import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Send = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6.04955 12H9.04667M6.04955 12L3.80357 5.30879C3.52376 4.4752 4.39272 3.71852 5.18839 4.10292L19.688 11.1079C20.4373 11.4699 20.4373 12.5301 19.688 12.8921L5.18838 19.8971C4.39272 20.2815 3.52376 19.5248 3.80357 18.6912L6.04955 12Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M5.51714 3.43012C4.12475 2.75715 2.60409 4.08189 3.09374 5.54129L5.01098 11.2556H9.04755C9.46136 11.2556 9.79682 11.5889 9.79682 12C9.79682 12.4111 9.46136 12.7444 9.04755 12.7444H5.01093L3.09374 18.4586C2.60409 19.918 4.12474 21.2427 5.51713 20.5698L20.0165 13.5618C21.3278 12.9281 21.3278 11.0718 20.0165 10.438L5.51714 3.43012Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
